export default{
    // @Partner
    newCreatedPartner: {},
}